import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import NotificationsContext from 'context/Notifications/NotificationsContext';
import { UnreadBadge } from 'components/LeftNav/styled';
var TaskLink = function (_a) {
    var pathTo = _a.pathTo, title = _a.title;
    var taskUnreadCount = useContext(NotificationsContext).taskUnreadCount;
    return (_jsxs(Link, { to: pathTo, style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        }, children: [title, taskUnreadCount > 0 && (_jsx(UnreadBadge, { "data-test": "taskUnreadBadge", children: taskUnreadCount }))] }));
};
export default TaskLink;
